class Interceptor {
  constructor() {
    this.queue = [];
  }
  use(fulfilled, rejected) {
    this.queue.push({ fulfilled, rejected });
  }
}

export { Interceptor };
